/** Regelversion 12: Erfolgskarte „Problem gelöst“ (engine/win12.ts). */
import { useGame, useS } from '../../store/game';
import { GROUPS } from '../../content/axes';
import { dateLabel, de, sg } from '../../engine/util';
import type { Win } from '../../engine/win12';

function Curve({ W }: { W: Win }) {
  const h = W.h.length > 1 ? W.h : [W.from, W.to], n = h.length, Wd = 260, H = 90, top = Math.max(60, ...h) + 5;
  const x = (i: number) => i / (n - 1) * Wd, y = (v: number) => H - v / top * H;
  const d = h.map((v, i) => `${i ? 'L' : 'M'}${x(i).toFixed(1)},${y(v).toFixed(1)}`).join('');
  const li = W.lawM != null ? W.lawM - W.m0 : -1;
  return (
    <svg viewBox={`0 0 ${Wd} ${H + 16}`} width="100%" height={H + 16} role="img" aria-label={`Problemdruck von ${W.from} auf ${W.to}`}>
      <line x1="0" x2={Wd} y1={y(20)} y2={y(20)} stroke="var(--rule)" strokeDasharray="3 4" />
      <text x="4" y={y(20) - 4} fill="var(--muted)" fontSize="10">gelöst unter 20</text>
      {li > 0 && li < n && <><line x1={x(li)} x2={x(li)} y1="0" y2={H} stroke="var(--accent)" /><text x={x(li) + 4} y="10" fill="var(--accent)" fontSize="10">Gesetz in Kraft</text></>}
      <path d={`${d} L${Wd},${H} L0,${H} Z`} fill="rgba(111,211,148,.12)" />
      <path d={d} fill="none" stroke="var(--good)" strokeWidth="2.5" />
      <circle cx={x(n - 1)} cy={y(h[n - 1])} r="4" fill="var(--good)" />
      <text x="0" y={H + 13} fill="var(--muted)" fontSize="10">{dateLabel(W.m0)}</text>
      <text x={Wd} y={H + 13} fill="var(--muted)" fontSize="10" textAnchor="end">{dateLabel(W.m)}</text>
    </svg>
  );
}

export function SolvedCard() {
  const S: any = useS(); const { dispatch } = useGame(); const W: Win | null = S.winCard; if (!W) return null;
  const gs = Object.keys(W.g).sort((a, b) => W.g[b] - W.g[a]);
  return (
    <div className="solved" role="status">
      <div className="sv-main">
        <span className="label">Erfolg · {dateLabel(W.m)}</span>
        <h3>{W.n}: {W.k === 'gelöst' ? 'gelöst' : 'entschärft'}</h3>
        <p>{W.k === 'gelöst'
          ? <>„<b>{W.law}</b>“ hat gewirkt. Das Problem spielt politisch keine Rolle mehr und verschwindet von der Liste.</>
          : <>„<b>{W.law}</b>“ wirkt jetzt voll. Der Problemdruck ist seit dem Höchststand um {de(W.from - W.to, 0)} Punkte gesunken. Hält er drei Monate unter 20, ist das Problem gelöst.</>}</p>
        <div className="tags">{gs.map((g) => <span key={g} className="tag up">{GROUPS[g]} {sg(W.g[g], 1)}</span>)}{W.prom && <span className="tag sv-prom">Wahlversprechen eingelöst</span>}</div>
      </div>
      <div className="sv-chart"><div className="sv-big"><s>{de(W.from, 0)}</s><span>→</span><b>{de(W.to, 0)}</b></div><span className="sub">Problemdruck</span><Curve W={W} /></div>
      <div className="actions sv-act"><button type="button" className="yes small" onClick={() => dispatch('winOk' as any)}>Weiter regieren</button></div>
      <span className="sv-stamp" aria-hidden="true">{W.k === 'gelöst' ? 'Gelöst' : 'Entschärft'}</span>
    </div>
  );
}
